import React from "react";
import '../../styles/imagebutton.css';

const ImageButton = (props) => {
    return (
        <div className="image-button" onClick={props.onClick}>
            <img src={props.image} alt="icon" />
            <div className="label">{ props.label }</div>
        </div>
    )
}
export default ImageButton;